











































































































































import { Component, Prop, Vue } from 'vue-property-decorator';
import Vuetify from 'vuetify';
import { ICompetition, ITheme, IResponse, IEntry } from '@/interfaces/objects';
import { stampService } from '@/services/stamp.service.ts';
import { fail } from 'assert';

interface Stamp {
    id: string;
    used: boolean;
    code: string;
}
interface StyleCSS {
        competition: {
                background: string;
                width: string;
                height: string;
                position: string;
                zIndex: number;
        };
        header: {
                width: string;
                zIndex: number;
        };
        footer: {
                width: string;
                zIndex: number;
                position: string;
                bottom: string;
                left: string;
        };
        section: {
                background: string;
                width: string;
                padding: string;
                margin: string;
                borderRadius: string;
        };
        title: {
                display: string,
                fontSize: string,
                fontWeight: string,
                color: string,
        };
        description: {
                display: string,
                fontSize: string,
                fontWeight: string,
                color: string,
        };
        stamps: {
                margin: string;
                textAlign: string;
        };
        stampArea: {
                border: string;
                width: string;
                height: string;
                background: string;
                display: string;
                margin: string;
                borderRadius: string;
        };
        stamp: {
                width: string;
                height: string;
        };
        stampIcon: {
                width: string;
                height: string;
                display: string;
        };
        stampInput: {
            border: string;
            width: string;
            textAlign: string
        };
}

@Component
export default class StampsComponent extends Vue {
    @Prop() public data?: any;
    public competition?: ICompetition;
    public stamps: Stamp[];
    public css?: object;
    public stampLimit: number = 0;
    public model?: any;
    public state?: string = 'stamps';
    public canRedeem: boolean = false;

    public redType?: string = 'pending..';
    public redValue?: string = 'pending..';

    constructor() {
        super();
        this.stamps = new Array();
        if (this.data && this.data.competition) {
            this.competition = this.data.competition as ICompetition;
        }
    }

    public created() {
        if (this.competition && this.competition.metaData) {
            this.competition.metaData.forEach((md) => {
                if (md.key === 'css') {
                    this.css = JSON.parse(md.value) as StyleCSS;
                }
                if (md.key === 'stamps') {
                    this.stampLimit = parseInt(md.value, 10);
                }
            });
            this.competition.metaData.forEach((md) => {
                if (md.key === 'theme') {
                    const theme = JSON.parse(md.value) as ITheme;
                    this.$vuetify.theme.primary = theme.primary;
                    this.$vuetify.theme.secondary = theme.secondary;
                    this.$vuetify.theme.accent = theme.accent;
                    this.$vuetify.theme.error = theme.error;
                    this.$vuetify.theme.warning = theme.warning;
                    this.$vuetify.theme.info = theme.info;
                    this.$vuetify.theme.success = theme.success;
                }
            });
            this.model = {
                entryId: 0,
                competitionId: this.competition.id,
                title: this.getString('title'),
                description: this.getString('description'),
                code: undefined,
            };
        }
    }
    public async mounted() {
        // this.$vuetify.theme.primary = '#FEA400';
        // this.$vuetify.theme.secondary = '#FF7A5E';
        // this.$vuetify.theme.accent = '#891800';
        // this.$vuetify.theme.error = '#FF0000';
        // this.$vuetify.theme.warning = '#FFC200';
        // this.$vuetify.theme.info = '#008BFF';
        // this.$vuetify.theme.success = '#0ED100';
        if (this.competition && this.competition.id) {
            await stampService.entry(this.competition.id)
            .then(async (r: IResponse) => {
                if (r.success) {
                    // tslint:disable-next-line:no-console
                    // const data = (r.data as IPreview);
                    // this.competition = r.data as ICompetition;
                    // this.isLoaded = true;
                    const entry = (r.data as IEntry);
                    this.model.entryId = entry.id;
                    await this._parseStamps(entry);
                } else {
                    if (r.status === 401) {
                        // this.isAuthenticated = false;
                    } else {
                        // tslint:disable-next-line:no-console
                        console.log('fail: ', r);
                    }
                }
            })
            .catch((c) => {
                // tslint:disable-next-line:no-console
                console.log('catch: ', c);
            });
        }                
    }

    private getString(key: string): string {
        let result = '{NOT_FOUND!}';
        if (this.competition && this.competition.metaData) {
            this.competition.metaData.forEach((md) => {
                if (md.key === key) {
                    result = (md.value as string);
                }
            });
        }
        return result;
    }
    private getNumber(key: string): number {
        let result = 0;
        if (this.competition && this.competition.metaData) {
            this.competition.metaData.forEach((md) => {
                if (md.key === key) {
                    result = Number(md.value);
                }
            });
        }
        return result;
    }

    private async _submitCode(): Promise<void> {
        if (this.model && this.model.code) {
            this.state = 'submit';
            await stampService.submit(this.model)
            .then(async (r: IResponse) => {
                if (r.success) {
                    // tslint:disable-next-line:no-console
                    // const data = (r.data as IPreview);
                    // this.competition = r.data as ICompetition;
                    // this.isLoaded = true;
                    const entry = (r.data as IEntry);
                    await this._parseStamps(entry);
                    this.state = 'stamps';
                } else {
                    if (r.status === 401) {
                        // this.isAuthenticated = false;
                    } else {
                        // tslint:disable-next-line:no-console
                        console.log('fail: ', r);
                        this.state = 'error';
                    }
                }
            })
            .catch((c) => {
                // tslint:disable-next-line:no-console
                console.log('catch: ', c);
            });
        }
    }
    private async _redeemStamps(): Promise<void> {
        // this.state = 'submit';
        if (this.model) {
            // this.state = 'redeem-status';
            await stampService.redeem(this.model)
            .then(async (r: IResponse) => {
                if (r.success) {
                    // tslint:disable-next-line:no-console
                    // console.log('redeem: ', r.data);

                    this.redType = r.data.redType;
                    this.redValue = r.data.redValue;

                    const entry = r.data.entry as IEntry;
                    this.model.entryId = entry.id;
                    this.stamps = new Array();
                    this._parseStamps(entry);
                    this.state = 'redeem-status';
                } else {
                    if (r.status === 401) {
                        // this.isAuthenticated = false;
                    } else {
                        // tslint:disable-next-line:no-console
                        console.log('fail: ', r);
                        this.state = 'error';
                    }
                }
            })
            .catch((c) => {
                // tslint:disable-next-line:no-console
                console.log('catch: ', c);
            });
        }
    }

    private async delay(ms: number) {
        return new Promise( (resolve) => setTimeout(resolve, ms) );
    }

    private async _parseStamps(entry: IEntry) {
        const stamps = entry.data.split('|');
        if (this.stamps.length === 0) {
            for (let index = 0; index < stamps.length; index++) {
                const stamp = stamps[index];
                this.stamps.push({
                    id: `Stamp_${index}`,
                    used: false,
                    code: stamp,
                });
            }
        }

        let unused = 0;
        for (let index = 0; index < stamps.length; index++) {
            const stamp = stamps[index];
            const isUsed = ((stamp === '#') ? false : true);
            this.stamps[index].used = isUsed;
            // await this.delay(350);
            if (!isUsed) {
                unused++;
            }
        }

        this.canRedeem = ((unused > 0) ? false : true);
    }
}
